<template lang="pug">
.event-replies-modal
  b-modal(v-model="_value" size="xl" :title="title" no-close-on-backdrop no-close-on-esc)
    .event-replies-modal-table
      .thead
        .header-line
          .th.resident-name 利用者名（部屋名）
          .th.family-name 予約家族名（続柄）
          .th.attendees-name 参加者名
          .th.attendees-type 参加種別
          .th.control 操作
      .tbody
        .body-line(v-for="item in items")
          .td.resident-name {{ item.residentName }}（{{ item.residentRoom }}）
          .td.family-name {{ item.familyName }}（{{ item.familyRelation }}）
          .td.attendees-name.d-flex.flex-column.justify-content-center.align-items-start
            .attendee-name(v-for="attendeeName in item.attendeeNames") {{ attendeeName }}
          .td.attendees-type.d-flex.flex-column.justify-content-center.align-items-start
            .attendee-type(v-for="attendeeType in item.attendeeTypes") {{ getAttendeeType(attendeeType) }}
          .td.control.center
            button.btn.edit-btn(@click="onEdit(item)" type="button" :class="{ 'disable': isExpired }" :disabled="isExpired") 編集
            button.btn.delete-btn(@click="onDelete(item)" type="button" :class="{ 'disable': isExpired }" :disabled="isExpired") 削除
    
    template(#modal-footer)
      .footer-note 参加申込み締切日以降も、施設側からは代理参加申込みと登録内容の編集・削除ができます。
      b-button.btn(@click="onGotoEventReplyRegister" type="button" :class="{ 'disable': isExpired }" :disabled="isExpired") 代理参加申込み
      b-button.btn(@click="onDownloadCsv" type="button") ファイルダウンロード
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { AttendType } from "@/commons/services/EventReplies";

/**
 * ### イベント返信モーダル
 */
@Component
export default class EventRepliesModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  @Prop({ required: true })
  items!: Array<EventRepliesTableModel>;

  @Prop({ required: true })
  title!: string;

  @Prop({ required: true })
  isExpired!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public getAttendeeType(attendeeType: AttendType): string {
    if (attendeeType == AttendType.LOCAL) {
      return "現地参加";
    } else {
      return "オンライン参加";
    }
  }

  /**
   * ### 編集ボタン押下を親コンポーネントに通知する
   */
  public onEdit(item: EventRepliesTableModel): void {
    this.$emit("editEventReplies", item);
    return;
  }

  /**
   * ### 削除ボタン押下を親コンポーネントに通知する
   */
  public onDelete(item: EventRepliesTableModel): void {
    this.$emit("deleteEventReplies", item);
    return;
  }

  /**
   * ### 代理参加申込みボタン押下を親コンポーネントに通知する
   */
  public onGotoEventReplyRegister(): void {
    this.$emit("gotoEventReplyRegister");
    return;
  }

  /**
   * ### CSVダウンロードボタン押下を親コンポーネントに通知する
   */
  public onDownloadCsv(): void {
    this.$emit("downloadCsv", { items: this.items, title: this.title });
    return;
  }
}
export interface EventRepliesTableModel {
  eventRepliesSortKey: string;
  residentName: string;
  residentRoom: string;
  familyName: string;
  familyRelation: string;
  attendeeNames: string[];
  attendeeTypes: Array<AttendType>;
}
</script>
